// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
*,
*:before,
*:after {
  box-sizing: border-box;
}

body {
  margin: 0;
}

form {
  display: grid;
  place-content: center;
}

input[type=checkbox] {
  appearance: none;
  background-color: var(--form-background);
  margin: 0;
  font: inherit;
  color: currentColor;
  width: 12px;
  height: 12px;
  border: 1px solid black;
  border-radius: 3px;
  transform: translateY(5px);
  display: grid;
  place-content: center;
}

input[type=checkbox]::before {
  content: " ";
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--form-control-color);
  background-color: CanvasText;
}

input[type=checkbox]:checked::after {
  content: "✓";
  font-size: 20px;
  margin-top: -3px;
  margin-left: 3px;
  text-align: center;
}

input[type=checkbox]:disabled {
  --form-control-color: var(--form-control-disabled);
  color: var(--form-control-disabled);
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/datatable/datatable.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;EAGE,sBAAA;AAEF;;AACA;EACE,SAAA;AAEF;;AACA;EACE,aAAA;EACA,qBAAA;AAEF;;AACA;EAEE,gBAAA;EACA,wCAAA;EACA,SAAA;EAEA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,qBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,uEAAA;EACA,mBAAA;EACA,6BAAA;EACA,uCAAA;EACA,mDAAA;EACA,4BAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kDAAA;EAEA,mCAAA;EACA,mBAAA;AAAF","sourcesContent":["*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n}\n\nform {\n  display: grid;\n  place-content: center;\n}\n\ninput[type=\"checkbox\"] {\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: var(--form-background);\n  margin: 0;\n\n  font: inherit;\n  color: currentColor;\n  width: 12px;\n  height: 12px;\n  border: 1px solid black;\n  border-radius: 3px;\n  transform: translateY(5px);\n  display: grid;\n  place-content: center;\n}\n\ninput[type=\"checkbox\"]::before {\n  content: \" \";\n  width: 0.65em;\n  height: 0.65em;\n  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);\n  transform: scale(0);\n  transform-origin: bottom left;\n  transition: 120ms transform ease-in-out;\n  box-shadow: inset 1em 1em var(--form-control-color);\n  background-color: CanvasText;\n}\n\ninput[type=\"checkbox\"]:checked::after {\n  content: \"✓\";\n  font-size: 20px;\n  margin-top: -3px;\n  margin-left: 3px;\n  text-align: center;\n}\n\ninput[type=\"checkbox\"]:disabled {\n  --form-control-color: var(--form-control-disabled);\n\n  color: var(--form-control-disabled);\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
